export default class MobileNavigation {
	private state: string;
	private navigationContainer: HTMLElement;
	private buttonClose: HTMLButtonElement;

	public constructor() {
		this.state = 'closed';
		this.navigationContainer = document.querySelector(
			'.header.default .menu-header-navigation-container'
		);
		this.buttonClose = document.querySelector('.header.default .close-button');

		if (!this.navigationContainer) {
			return;
		}

		document.querySelectorAll('.mobile-navigation-toggle').forEach((toggle: HTMLElement) => {
			toggle.addEventListener('click', this.toggleNavigation);
		});

		window.addEventListener('resize', this.updateA11y);

		this.updateA11y();
	}

	private updateA11y = (): void => {
		this.navigationContainer.inert =
			window.getComputedStyle(this.buttonClose).display !== 'none' && this.state === 'closed';
		this.buttonClose.disabled = this.state === 'closed';
		this.buttonClose.setAttribute('aria-disabled', String(this.state === 'closed'));
		this.buttonClose.setAttribute('aria-hidden', String(this.state === 'closed'));
	};

	private toggleNavigation = (): void => {
		switch (this.state) {
			case 'closed':
				document.body.classList.add('mobile-navigation-is-visible');
				this.state = 'open';
				break;
			case 'open':
				document.body.classList.remove('mobile-navigation-is-visible');
				this.state = 'closed';
				break;
		}

		this.updateA11y();
	};
}
